var _rect, _circle, _circle2, _line, _line2, _line3, _line4, _line5, _text, _path, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "historyGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F5F0E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#E5DECF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#5F7A61"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 48,
    height: 40,
    fill: "url(#historyGradient)",
    rx: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 32,
    r: 6,
    fill: "#E5DECF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 32,
    r: 6,
    fill: "#E5DECF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 48,
    y2: 20,
    stroke: "#1C1917",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 26,
    x2: 44,
    y2: 26,
    stroke: "#1C1917",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 32,
    x2: 46,
    y2: 32,
    stroke: "#1C1917",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 38,
    x2: 42,
    y2: 38,
    stroke: "#1C1917",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 44,
    x2: 40,
    y2: 44,
    stroke: "#1C1917",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 58,
    fill: "#5F7A61",
    fontSize: 8,
    fontWeight: "bold",
    textAnchor: "middle"
  }, "Est. 1975")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 50 8 Q 54 4 58 8 Q 54 12 50 16 L 46 20 L 42 16 Z",
    fill: "#5F7A61"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 20,
    x2: 40,
    y2: 26,
    stroke: "#E5DECF",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.682321e52f8d0892f5fc37bb638ea44e.svg";
export { ForwardRef as ReactComponent };